// https://docs.aws.amazon.com/sdk-for-javascript/v2/developer-guide/s3-example-photos-view-full.html

const S3Client = function (albumBucketName, region, identityPoolId, containerSelector, onImageClick) {

	AWS.config.region = region; //"eu-west-1"; // Region
	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: identityPoolId//"eu-west-1:c9806491-ff19-4eaf-b0e8-72e9b57e1c88",
	});
	this.containerSelector = containerSelector;
	this.onImageClick = onImageClick;
	this.onLoadingStart = null;
	this.onLoadingEnd = null;

	// Create a new service object
	this.client = new AWS.S3({
		apiVersion: "2006-03-01",
		params: { Bucket: albumBucketName },
	});

	this.getHtml = function (template) {
		return template.join("");
	};

	this.renderObjectList = function (data, endpointHref, renderFolders = true, renderFiles = true) {
		var trimEnd = function (s) {
			while (s.length > 0 && s.endsWith("/")) {
				s = s.substr(0, s.length - 1);
			}
			return s;
		};

		const self = this;
		const containerExpression = "$(this).parents('" + this.containerSelector + "')[0]";

		var parts = trimEnd(data.Prefix).split("/");
		parts.pop();
		var html = [];

		html.push("<h2>");
		if (data.Prefix !== "") {
			html.push("<button class='fad fa-chevron-left' onclick=\"" + containerExpression + ".viewAlbum('" + parts.join('/') + "')\"></button>");
			html.push(data.Prefix);
		} else {
			html.push("&nbsp;");
		}
		html.push("</h2>");

		html.push("<ul>");

		if (renderFolders) {
			var albums = data.CommonPrefixes.map(function (commonPrefix) {
				var prefix = decodeURIComponent(trimEnd(commonPrefix.Prefix));
				var albumName = trimEnd(commonPrefix.Prefix).split("/").pop();
				return self.getHtml(["<li>", '<button onclick="' + containerExpression + '.viewAlbum(\'' + prefix + '\')\">', '<i class="fad fa-folder-open"></i>', "<span>" + albumName + "</span>", "</button>", "</li>"]);
			});
			
			html.push(this.getHtml(albums));
		}

		if (renderFiles) {
			var bucketUrl = endpointHref + albumBucketName + "/";

			var photos = data.Contents.map(function (photo) {
				if (photo.Size == 0) return;
				var photoKey = photo.Key;
				var photoUrl = bucketUrl + encodeURIComponent(photoKey);
				return self.getHtml(["<li>", '<button onclick="' + containerExpression + '.onImageClick(\'' + photoUrl + '\')">', '<img src="' + photoUrl + '" crossorigin="anonymous"/>', '</button>', "</li>"]);
			});
			
			html.push(this.getHtml(photos));
		}
		html.push("</ul>");

		$(this.containerSelector).html(this.getHtml(html));

		let container = $(this.containerSelector)[0];
		// always overwrite
		container.viewAlbum = this.viewAlbum.bind(this);
		container.onImageClick = this.fireOnImageClick.bind(this);
	};

	this.fireOnImageClick = function (url) {
		if (typeof (this.onImageClick) == 'function')
			this.onImageClick(url);
	}

	this.viewAlbum = function (albumName) {
		var albumPhotosKey = albumName !== "" ? albumName + "/" : "";
		const self = this;
		const $container = $(this.containerSelector);
		$container.addClass("loading");
		this.client.listObjectsV2({ Delimiter: "/", Prefix: albumPhotosKey }, function (err, data) {
			if (err) {
				return alert("There was an error viewing your album: " + err.message);
			}
			self.renderObjectList(data, this.request.httpRequest.endpoint.href, true, true);
			$container.removeClass("loading");
		});
	}
};
